import { isSabreBedbankSupplier } from 'lib/hotels/hotelLoyaltyEligibility'

export function isSabreBedbankPropertyRate(rate: App.PropertyRate): boolean {
  return rate.type === 'bedbank' && isSabreBedbankSupplier(rate.bedbankSupplierCode)
}

export function filterSabreRatesFromPropertyRoomRates(
  rooms: Array<App.PropertyRoomRates>,
  sabreHotelsEnabled: boolean,
): Array<App.PropertyRoomRates> {
  if (sabreHotelsEnabled) return rooms

  return rooms.map(room => {
    if ('unavailableReason' in room) return room
    return {
      ...room,
      hotelOnlyRates: room.hotelOnlyRates.filter(rate => !isSabreBedbankPropertyRate(rate)),
      hotelWithFlightsRates: room.hotelWithFlightsRates.filter(rate => !isSabreBedbankPropertyRate(rate)),
    }
  })
}
